import React,{ Fragment } from "react";
import { Table } from "react-bootstrap";
import { Breadcrumb, SelectBox,CustomModal, Recalled} from "../components";
import { Button } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { BASE_URL } from "../store/constant";
import Axios from "axios";
import styled from "styled-components";
import moment from "moment";
import _ from 'lodash'
import { exportTableToExcel } from '../utils'
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import get from "lodash/get";
import { toast } from "react-toastify";


const PrintSection = styled.section`
  @media print {
    table,
    thead > tr:first-child > td {
      border-top: 0 !important;
      border-top-color: transparent !important;
      border-left: 0 !important;
      border-left-color: transparent !important;
      border-right: 0 !important;
      border-right-color: transparent !important;
    }
  }
`;


class RecalledAmountAdjusted extends React.Component {
  state = {
    openModalByCSMCNo: false,
    stateData: {},
    statesList: [],
    RecalledStatewise: [],
    RecalledStatewiseCR:[],
    releaseAdjustment:[],
    state: '',
    recolledID:'',
    isLoading: true,
  };
  componentDidMount = async () => {
    this.setState({ isLoading: true });
    try{
    console.log('Recalled===>>>',this.props)

    const { data } = await Axios.get(`${BASE_URL}/states`);
    const { data: RecalledStatewise } = await Axios.get(`${BASE_URL}/exces/recalledData`);
    const { data: RecalledStatewiseCR } = await Axios.get(`${BASE_URL}/exces/recalledCRData`);
    const { data: releaseAdjustment } = await Axios.get(`${BASE_URL}/release/releaseAdjustment`);
    this.setState({
      recolledID:this.props.recalledID,
      RecalledStatewise,RecalledStatewiseCR,releaseAdjustment, statesList: _.map(data, (o) => ({ label: o.statename, value: o.statecode, ...o, StateCode: o.statecode })),

      isLoading: false,

    });

  }catch (err) {
        this.setState({ isLoading: false });
        toast.error("Something went wronge.");
      }


  };

  render() {
    const {
      recolledID,
      statesList,
      RecalledStatewise,
      state,
      RecalledStatewiseCR,
      releaseAdjustment

    } = this.state;
    let combRow=0;
    let Sno=0;
    let realvaluecheck=[]
    let gtAmountAlreadyAdjusted=0,gtAmountAlreadyAdjustedTotal=0,gtBlanceAmountForAdjustment=0

    const fltStateWiseRecalledData = _.filter(RecalledStatewise, obj => obj.recalled_Id === recolledID)
    const fltStateWiseAdjustedData = _.filter(RecalledStatewiseCR, obj => obj.recalled_Id === recolledID)

    const gtAmountAvailableForAdjustment= _.sumBy(fltStateWiseRecalledData,o=> Number(o.recaalledAmount || 0 ))
   // const FltreleaseAdjustmentStateWise=state ? _.filter(releaseAdjustment, obj => obj.StateCode === state.value) : [];


    return (
      <React.Fragment>
      
      <PrintSection ref={(el) => (this.printTableRef = el)}>
          <Table bordered className="bg-c-white" id="RecalledAmountAdjusted">
          <thead className="text-white text-center" style={{ backgroundColor: "#005a99" }} >

<tr>
  <th rowSpan={2} className="text-left">
    {" "} Name of the <br />State/UT </th>
  <th colSpan={12} style={{ background: "#5f7682" }}>Recalled for Refund</th>
 
</tr>
<tr>
  <th style={{ background: "#566164" }}>Sr.<br />No.</th>
  <th style={{ background: "#566164" }}>Recalled<br />ID</th>

  <th style={{ background: "#566164" }}>Recalled Amount <br />for adjustment<br/><span className="text-c-yellow">(₹ in Cr.)</span></th>
  <th style={{ background: "#566164" }}>Amount <br />already <br />Adjusted <br/><span className="text-c-yellow">(₹ in Cr.)</span></th>
  <th style={{ background: "#566164" }}>Balance <br />Amount <br />for <br />adjustment <br/><span className="text-c-yellow">(₹ in Cr.)</span></th>
  <th style={{ background: "#566164" }}>Action</th>
  
</tr>
</thead>
            <tbody>
              {
                _.map(fltStateWiseRecalledData, (obj, i) => {
                  console.log('obj---------->>>>>>>>',obj);
                let installmentvalue=0;
                let BlanceAmount=0;
                const fltCrData=_.filter(fltStateWiseAdjustedData,flt=>(flt.recalled_Id===obj.recalled_Id)&&(flt.sanctionPdfMatchId===obj.sanctionPdfMatchId)&&(flt.head===obj.head))
                
                const fltCrDataflt=_.isEmpty(fltCrData)?[{}]:fltCrData
                const adjustmentLength=fltCrDataflt.length
                const AmountAlreadyAdjusted = _.sumBy(fltCrData,o=> Number(o.recaalledAmount || 0 ))
                gtAmountAlreadyAdjusted +=AmountAlreadyAdjusted
 const AmountAlreadyAdjustedTotal = (_.get(obj,'recaalledAmount')? Number(_.get(obj,'recaalledAmount')):0)-Number(AmountAlreadyAdjusted)
                gtAmountAlreadyAdjustedTotal +=AmountAlreadyAdjustedTotal

                  return (
                    <Fragment key={i}>
                      {
                        _.map(fltCrDataflt, (objAdj, idx) => {
                          installmentvalue +=1
                          combRow +=1
                          Sno +=1
                          console.log('objAdj---------->>>>>>>>',objAdj);
                        let checkvalueForcomb=_.filter(fltStateWiseAdjustedData,flt=>flt.recalled_Id===obj.recalled_Id).length;
                        let deleteoption=checkvalueForcomb
                        console.log('checkvalueForcomb------>>>>',checkvalueForcomb);
                        const DrRecalledLength=_.filter(fltStateWiseRecalledData,flt=>flt.recalled_Id===obj.recalled_Id).length
                          if(checkvalueForcomb){
                            checkvalueForcomb=checkvalueForcomb<DrRecalledLength?DrRecalledLength:checkvalueForcomb
                          }
                       // console.log('fltStateWiseAdjustedData---->',fltStateWiseAdjustedData);//Cr data
                       // console.log(i,'<----fltStateWiseRecalledData---->',fltStateWiseRecalledData); // Dr
                        if(_.includes(realvaluecheck, obj.recalled_Id)){
                        }else{
                          realvaluecheck.push(obj.recalled_Id)
                          combRow =0;
                        }
                      checkvalueForcomb =checkvalueForcomb ? checkvalueForcomb:_.filter(fltStateWiseRecalledData,flt=>flt.recalled_Id===obj.recalled_Id).length
                    
                     BlanceAmount +=Number(_.get(objAdj,'recaalledAmount') ? Number(_.get(objAdj,'recaalledAmount')):0)
                      const BlanceAmountForAdjustment=(_.get(obj,'recaalledAmount')? Number(_.get(obj,'recaalledAmount')):0) - Number(BlanceAmount)            
                      gtBlanceAmountForAdjustment +=BlanceAmountForAdjustment

                        const fltAdjustmentMatchId=_.first(_.filter(releaseAdjustment,o=>(o.sanctionPdfMatchId===objAdj.matchId)&&(o.head===objAdj.head))) 
                        
                          return (
                            <tr key={i} className="text-right">           
                             {installmentvalue===1 ? <td rowSpan={adjustmentLength} className="text-left">{state ? state.label : '-'}</td>:''}
                             {installmentvalue===1 ? <td rowSpan={adjustmentLength} style={{ maxWidth: 30 }} className="text-center"> {i + 1} </td>:''}
                            
                            {combRow===0? <td rowSpan={checkvalueForcomb?checkvalueForcomb:1} className="text-center" onClick={() => this.setState({ openModalByCSMCNo: obj.recalled_Id })}>{obj.recalled_Id}</td>:'' } 
       
                            {installmentvalue===1 ? <td rowSpan={adjustmentLength}>{obj.recaalledAmount?((obj.recaalledAmount).toFixed(5)).toLocaleString('en-in'):'-'}</td>:''}
                            {installmentvalue===1 ? <td rowSpan={adjustmentLength}>{AmountAlreadyAdjusted?AmountAlreadyAdjusted.toFixed(5):'-'}</td>:''}
                            {installmentvalue===1 ? <td rowSpan={adjustmentLength}>{AmountAlreadyAdjustedTotal?AmountAlreadyAdjustedTotal.toFixed(5):'-'}</td>:''}
                            {combRow===0? <td rowSpan={checkvalueForcomb?checkvalueForcomb:1} className="text-center">
                              
                             <Button
                                          title="Un-Do"
                                          variant="outline-danger"
                                          onClick={async () => {

                                            await Axios.post(
                                              `${BASE_URL}/sanction-utilization-order/refunddata`,{recalled_Id:obj.recalled_Id}).then(async (res)=>{
                                               toast.success("Refund Successfully ,Refresh and Checked.");
                                              const { data: RecalledStatewise } = await Axios.get(`${BASE_URL}/exces/recalledData`);
                                              const { data: RecalledStatewiseCR } = await Axios.get(`${BASE_URL}/exces/recalledCRData`);
                                              const { data: releaseAdjustment } = await Axios.get(`${BASE_URL}/release/releaseAdjustment`);
                                              this.setState({ RecalledStatewise,RecalledStatewiseCR,releaseAdjustment});
                                             
                                            }).catch(err=>{
                                              console.log(err);
                                              toast.success("Refund operation already done.");
                                            })
                                           
                                          }}
                                        >
                                          <i className="fa fa-undo"></i>
                                        </Button> 
                              
                              </td>:'' } 

                          </tr>
                          )
                        })
                      }
                    </Fragment>
                  )
                })
              }

            </tbody>
          </Table>
          </PrintSection>
      
          </React.Fragment>
    );
  }
}

export default RecalledAmountAdjusted;
